import { Deal } from '@types';

export const groupFinancialsByCategory = (metrics: Deal['financial_metrics']) => {

  return metrics.reduce((acc, metric) => {
    const group = metric.category.includes('Revenue') ? 'Revenue' : metric.category.includes('Expense') ? 'Expenses' : metric.category.includes('Income') ? 'Income' : 'Other';

    if (!acc[group]) {
      acc[group] = [];
    }
    acc[group].push(metric);
    return acc;
  }, {} as Record<string, typeof metrics>);
};

export const validateMetricValue = (value: string | number): boolean => {
  const numValue = typeof value === 'string' ? Number(value.replace(/[^0-9.-]/g, '')) : value;
  return !isNaN(numValue);
};

// Format currency with compact notation for large numbers and multi-currency support
export const formatCurrency = (value?: number, currency: 'USD' | 'EUR' = 'USD'): string => {
  if (value === undefined || value === null || isNaN(value)) return 'N/A';

  // Convert value for EUR (simplified conversion for demo)
  const convertedValue = currency === 'EUR' ? value * 0.85 : value;

  // For values >= 1 million, format as "X.XX Million"
  if (Math.abs(convertedValue) >= 1000000) {
    return new Intl.NumberFormat(currency === 'EUR' ? 'de-DE' : 'en-US', {
      style: 'currency',
      currency: currency,
      notation: 'compact',
      maximumFractionDigits: 2
    }).format(convertedValue);
  }

  // For regular values, use standard formatting
  return new Intl.NumberFormat(currency === 'EUR' ? 'de-DE' : 'en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(convertedValue);
};

// Format percentage
export const formatPercent = (value?: number): string => {
  if (value === undefined || value === null || isNaN(value)) return 'N/A';
  return `${(value * 100).toFixed(1)}%`;
};
